import React, { useState } from 'react';
import { Container, Typography, Grid, TextField, Button, Box, Paper } from '@mui/material';
import PageTitle from '../components/PageTitle';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    try {
      const response = await fetch('https://api.getyoursolution.in/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
      console.log(result.success);
      if (result) {
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        // alert('Failed to send message. Try again later.');
      }
    } catch (error) {
      // console.error('Error:', error);
      // alert('Something went wrong!');
    }
  };
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <PageTitle title="Contact Us" />
      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h2" component="h1" align="center" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="h5" align="center" color="textSecondary" paragraph>
            Get in touch with our legal experts
          </Typography>

          <Grid container spacing={6} sx={{ mt: 4 }}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 4 }}>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Full Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Message"
                        name="message"
                        multiline
                        rows={4}
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                      >
                        Send Message
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 4, height: '100%' }}>
                <Typography variant="h4" gutterBottom>
                  Our Office
                </Typography>
                <Typography paragraph>
                120/40/2B/1A, Kasari Masari
                  <br />
                  Prayagraj, U.P 211011
                </Typography>
                <Typography paragraph>
                  <strong>Phone:</strong> (+91) 8299866226
                  <br />
                  <strong>Email:</strong> info@shoorawelfare.com
                </Typography>
                <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                  Office Hours
                </Typography>
                <Typography>
                  Monday - Friday: 9:00 AM - 6:00 PM
                  <br />
                  Saturday: By appointment only
                  <br />
                  Sunday: Closed
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Contact;